/**
 * Central Management > 통합관리 > 통합 스크립트
 *  store

 * @since 2018-06-29
 * @author devp018

 * @since 2018-09-13
 * @author devp017
 *
 */
export const state = () => ({
  // script: script,
  apiUrlPath: {
    script: '/api/cm/integrate-script'
  },
  isActive: true,
  isScriptTap: true,
  isColPopupShow: false,
  totalDataCount: 0,
  totalPageCount: 0,
  maxRecord: 0,
  pageSize: 5,
  searchData: [],
  scriptData: [],
  scriptDataList: [],
  scriptViewData: {},
  errorMessage: null
})
export const mutations = {
  setIsActive (state, payload) {
    state.isActive = Object.freeze(payload)
  },
  setScriptTab (state, payload) {
    state.isScriptTap = Object.freeze(payload)
  },
  setscriptViewData (state, payload) {
    (payload !== undefined) ? state.scriptViewData = payload : state.scriptViewData = [] // popup 창에서 입력필드로 사용하는 data
  },
  mutAcsSearchDataList (state, keyword) {
    state.isActive = Object.freeze(true)
    if (keyword === '') {
      state.scriptDataList = Object.freeze(state.scriptData)
    } else {
      state.scriptDataList = Object.freeze(state.scriptData).filter(item => {
        const cfgDtIsNotNullOrUndefinedIndex = item.cfg_dt !== null && item.cfg_dt !== undefined && item.cfg_dt.indexOf(keyword) >= 0
        const scriptUnameIsNotNullOrUndefinedIndex = item.script_uname !== null && item.script_uname !== undefined && item.script_uname.indexOf(keyword) >= 0
        const scriptDescIsNotNullOrUndefinedIndex = item.script_desc !== null && item.script_desc !== undefined && item.script_desc.indexOf(keyword) >= 0
        const scriptCntntIsNotNullOrUndefinedIndex = item.script_cntnt !== null && item.script_cntnt !== undefined && item.script_cntnt.indexOf(keyword) >= 0
        const type = [cfgDtIsNotNullOrUndefinedIndex, scriptUnameIsNotNullOrUndefinedIndex, scriptDescIsNotNullOrUndefinedIndex, scriptCntntIsNotNullOrUndefinedIndex]

        return type.some(i => i)
      })
    }
    state.maxRecord = Object.freeze(state.scriptDataList.length)
  },
  setscriptData () {},
  // 본문 리스트
  mutGetIntegrateScript (state, payload) {
    if (payload.length < 1) {
      state.scriptData = []
      state.scriptDataList = []
    } else {
      state.scriptData = Object.freeze(payload)
      state.scriptDataList = Object.freeze(payload)
    }
    state.maxRecord = Object.freeze(state.scriptDataList.length)
  },
  // 엑셀저장
  excelSave () {},
  fnColPopupShow (state, trueOrFalse) {
    state.isColPopupShow = Object.freeze(trueOrFalse)
  },
  mutationErrorMessage (state, payload) {
    state.errorMessage = payload
  }
}

export const actions = {
  // data table 키워드 검색
  acsSearchDataList ({commit, state}, keyword) {
    commit('mutAcsSearchDataList', keyword)
  },
  async setScriptExecute ({commit, state}, { formData, secure = false } = {}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$post(`${state.apiUrlPath.script}/execute`, formData, {
        successAlert: false,
        secure
      })
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async getIntegrateScript ({commit, state}, payload) {
    try {
      const data = await this.$axios.$get(`${state.apiUrlPath.script}/${payload}`)
      if (data.code.toUpperCase() !== 'OK') {
        this.$router.app.$alertPopUp.show(data.result.msg)
        return {code: 'nok', errors: data.result.msg}
      }
      commit('mutGetIntegrateScript', data.result)
      return {code: 'ok'}
    } catch (error) {
      this.$router.app.$alertPopUp.show(error)
      return {code: 'error', errors: error}
    }
  },
  async acsAddScriptData ({commit, state, dispatch}, { formData = {}, secure = false } = {}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$post(`${state.apiUrlPath.script}`, formData, {
        successAlert: false,
        secure
      })
      if (res.code === 'ok') {
        dispatch('getIntegrateScript', 0)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async acsEditScriptData ({commit, state, dispatch}, { formData = {}, secure = false } = {}) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      res = await this.$axios.$put(`${state.apiUrlPath.script}/${formData.script_id}`, formData, {
        successAlert: false,
        secure
      })
      if (res.code === 'ok') {
        dispatch('getIntegrateScript', 0)
      }
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  // 신청 항목 삭제
  async acsDeleteRequestScript ({commit, state, dispatch}, payload) {
    try {
      const data = await this.$axios.$delete(`${state.apiUrlPath.script}/${payload.script_id}`, {successAlert: false})
      if (data.code.toUpperCase() !== 'OK') {
        return {code: 'nok', errors: data.result.msg}
      }
      dispatch('getIntegrateScript', 0)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  },
  async finalCommand ({commit, state, dispatch}, type) {
    let param = {}
    if (type === 'apply') {
      param = { applyMsg: true, loading: false }
    } else {
      param = { cancelMsg: true, loading: false }
    }

    try {
      const data = await this.$axios.$put(`${state.apiUrlPath.script}/${type}`, null, param)
      if (data.code.toUpperCase() !== 'OK') {
        return {code: 'nok', errors: data.result.msg}
      }
      // dispatch('getIntegrateScript', 0)
      return {code: 'ok'}
    } catch (error) {
      return {code: 'error', errors: error}
    }
  }
}
export const getters = {
}

export const strict = false
